import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import './index.css'

const BsyTooltip = ({
  text,
  position = 'top',
  trigger = 'hover',
  className = '',
  offset = 5,
  type = "default",
  style = {},
  children
}) => {
  const [show, setShow] = useState(false);
  const refTarget = useRef(null);
  
  const handleMouseEnter = () => {
    if (trigger === 'hover') {
      setShow(true);
    }
  };
  
  const handleMouseLeave = () => {
    if (trigger === 'hover') {
      setShow(false);
    }
  };
  
  const handleClick = () => {
    if (trigger === 'click') {
      setShow(!show);
    }
  };
  
  const getPositionClass = () => {
    switch (position) {
      case 'top':
        return 'tooltip-top';
      case 'bottom':
        return 'tooltip-bottom';
      case 'left':
        return 'tooltip-left';
      case 'right':
        return 'tooltip-right';
      default:
        return '';
    }
  };

  const getPositions = () => {
    const rectTarget = refTarget.current ? refTarget.current.getBoundingClientRect() : {};
    switch (position) {
      case 'top':
        return {
            top: rectTarget.top - offset,
            left: rectTarget.left + rectTarget.width / 2
          };
      case 'bottom':
        return {
            top: rectTarget.top - offset,
            left: rectTarget.left + rectTarget.width / 2
          };
      case 'left':
        return {
            top: rectTarget.top,
            left: rectTarget.left - offset
          };
      case 'right':
        return {
            top: rectTarget.top,
            left: rectTarget.left + offset
          };
      default:
        return  {
            top: rectTarget.top - offset,
            left: rectTarget.left + rectTarget.width / 2
          };
    }
  };


  const rect = getPositions();

  const pos = {
    top: rect.top,
    left: rect.left
  }

  const TipDom = () => <div className='bsy-tooltip-container' style={{height: 0,position: "relative",zIndex: window.FX.STATIC.zIndex++}}>
    <div style={{position: "absolute",...pos}} className={`bsy-tooltip bsy-tooltip-content ${getPositionClass()} ${type}`}>
      <div className={`tooltip-content`}>{text}</div>
    </div>
  </div>;
  const element = <TipDom />;

  return (
    <div
      className={`tooltip-container ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
      style={style}
      ref={refTarget}
    >
      {children}
      {show && ReactDOM.createPortal(element, document.body)}
    </div>
  );
};

BsyTooltip.propTypes = {
  text: PropTypes.string.isRequired,
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  trigger: PropTypes.oneOf(['hover', 'click']),
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
  type: PropTypes.string
};

export default BsyTooltip;